// Types
import { GameSortType, GAME_SORT_ENUMS } from "types/Games";

export const GAME_SORT: GameSortType[] = [
  {
    id: GAME_SORT_ENUMS.ABC,
    title: "sort.games.alphabet",
    option: GAME_SORT_ENUMS.ABC,
  },
  {
    id: GAME_SORT_ENUMS.ZYX,
    title: "sort.games.alphabet-reverse",
    option: GAME_SORT_ENUMS.ZYX,
  },
  {
    id: GAME_SORT_ENUMS.NEW,
    title: "sort.games.new",
    option: GAME_SORT_ENUMS.NEW,
  },
  {
    id: GAME_SORT_ENUMS.POP,
    title: "sort.games.popular",
    option: GAME_SORT_ENUMS.POP,
  },
];
